import React from "react"
import { graphql } from "gatsby"

import { Meta } from "@shared"
import { CONSTANTS, URLS, CONTENT } from "@data"
import { logTool, featureFlag } from "@jsUtils"

import {
  Footer,
  Header,
  HeroGrid,
  GetInTouch,
  ContactFormFeature,
  ContactEmails
} from "@components/sections"

import Styles from "@pageStyles/contact.module.scss"

const { PAGE_NAMES, THEMES, COLORS, PAGE_TRACKER_KEYS, PAGE_TRACKER_VALUES } = CONSTANTS
const { GET_IN_TOUCH } = CONTENT
const { CONTACT } = GET_IN_TOUCH

const log = logTool()

/**
 * Contact Page
 * @param {object} props - react props
 * @todo hook up meta data
 */
const ContactPage = props => {
  const { data } = props
  const { contentfulContact, contentfulPageMeta } = data
  const { images, contacts } = contentfulContact
  log("Contact Content:", { contentfulContact, contentfulPageMeta })

  return (
    <>
      <Meta
        base={contentfulPageMeta}
        page={contentfulContact}
        hubSpotObj={{
          contentTypeKey: PAGE_TRACKER_KEYS.CONTACT_US,
          contentTypeValue: PAGE_TRACKER_VALUES.LANDING_PAGE
        }}
      />
      <Header theme={THEMES.TIN} pageColor={COLORS.DARK} />

      <HeroGrid
        shortHeroSection
        theme={THEMES.TIN}
        color={COLORS.FLURO}
        page={PAGE_NAMES.CONTACT}
        content={contentfulContact}
        classes={{
          headerText: Styles.contactHeroText
        }}
      />
      <ContactFormFeature
        theme={THEMES.LIGHT}
        color={COLORS.FLURO}
        data={{ images }}
        pageSource="Contact Page"
      />
      <ContactEmails theme={THEMES.TIN} data={contacts} />
      {featureFlag("getInTouchSupport") && (
        <GetInTouch
          theme={THEMES.DARK}
          color={COLORS.FLURO}
          headline={CONTACT.headline}
          subhead={CONTACT.subhead}
          ctaCopy={CONTACT.ctaCopy}
          ctaLink={URLS.SUPPORT()}
        />
      )}
      {/* {isModalEnabledOnSite ? (
        <EmailModal data={contentfulCrmEventBasedModal} theme={THEMES.DARK} color={COLORS.FLURO} />
      ) : null} */}
      <Footer />
    </>
  )
}

/**
 * pageQuery for Our People Page
 * @todo is there a way to make the global data a fragment?
 */
export const pageQuery = graphql`
  {
    contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      ...GlobalMetaData
    }
    contentfulCrmEventBasedModal {
      heroImage {
        title
        fluid(quality: 100, maxWidth: 1920) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      supportingText
      heroText
      isModalEnabledOnSite
    }
    contentfulContact {
      slug
      pageMeta {
        ...PageMetaData
      }
      title
      headline
      subhead
      ...ContactFormFeatureSection
      contacts {
        ...ContactEmailsSection
      }
    }
  }
`

export default ContactPage
